/** @jsx jsx */
import { defer, once, debounce } from 'lodash'
import { changeNodeAtPath, getNodeAtPath } from 'react-sortable-tree'
import { globalOnDemandVars } from '../../../helper/context'
import { getET1Index, textToGeneralizedTextElement, undoManager } from '../../../helper/functions'

export const getNodeKey = ({ node }) => (node.id)
export const getRootNode = (treeData, path) => {
  try {
    return (path.length !== 0 ? getNodeAtPath({
      path: path,
      treeData: treeData,
      getNodeKey: getNodeKey
    }).node : null
    )
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.error(e)
    }
    return null
  }
}
export const getSubTree = (treeData, path) => {
  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'getSubTree',
      value: {
        treeData,
        path,
        getNodeAtPath: (getNodeAtPath({ path: path, treeData: treeData, getNodeKey: getNodeKey, ignoreCollapsed: false }))
      },
      preview: path
    // , important: true
    })
  }
  return path.length !== 0 ? ((getNodeAtPath({
    path: path,
    treeData: treeData,
    getNodeKey: getNodeKey,
    ignoreCollapsed: false
  }).node.children) || []) : treeData
}
export const mergedTree = (mainTree, subTree, rootNode, path) => {
  rootNode.children = subTree
  // console.tron.display({
  //   name: 'mergedTree',
  //   value: {
  //     mainTree, subTree, rootNode, path
  //   },
  //   preview: path
  //   // , important: true
  // })
  return changeNodeAtPath({ treeData: mainTree, path: path, newNode: rootNode, getNodeKey: getNodeKey, ignoreCollapsed: false })
}

export const getPathList = (that, treeData, path) => {
  const isPixelMode = globalOnDemandVars.isPixelMode()
  const getGlobalTreeData = isPixelMode ? globalOnDemandVars.pixelTreeData : globalOnDemandVars.globalTreeData

  const registerToUndoManager = (setNextState) => {
    const prevPath = that.state.path
    const prevSubtreeData = that.state.subTreeData
    const prevRootNode = that.state.rootNode
    const prevPathList = that.state.pathList

    undoManager.add({
      redo: () => {
        if (process.env.NODE_ENV !== 'production') {
          console.tron.log('undoredo / redo')
        }
        setNextState()
      },
      undo: () => {
        if (process.env.NODE_ENV !== 'production') {
          console.tron.log('undoredo / undo')
        }
        that.setState({
          path: prevPath,
          subTreeData: prevSubtreeData,
          rootNode: prevRootNode,
          pathList: prevPathList,
          didUpdateAtCurrentPath: false
        })
      }
    })
  }
  const pathList = []
  // 반목문이 아니라 재귀로 만든건 treeData를 순회하는걸 최대한 줄이기위해서임
  // const pathExceptedRoot = path.slice(0, -1)
  const pathExceptedRoot = path.slice(0)
  const pathLastIndex = pathExceptedRoot.length - 1
  const getPathListF = (subTreeData, currentPath, pathIndex) => {
    if (pathLastIndex >= pathIndex) {
      const node = getNodeAtPath({
        treeData: subTreeData,
        // path: currentPath !== 0 ? path.slice(currentPath).map((n) => (n - (path[currentPath - 1]))) : path,
        path: currentPath.slice(0, 1),
        getNodeKey: getNodeKey,
        ignoreCollapsed: false
      }).node

      const nodeTitleElement = textToGeneralizedTextElement(node.title)

      const currentPagePnClickHandler = () => {
        that.state.scrollElement.scrollTop = 0
        defer(() => {
          that.arrayForRefs[getET1Index(-1)].enterFromOutside()
        })
      }

      const setNextState = () => {
        that.setState((state, props) => {
          const realTimePath = state.path
          const border = pathIndex + 1
          const newPath = realTimePath.slice(0, border)
          // const subPathOfSubTree = realTimePath.slice(border).map((v) => (v - (newPath[border - 1] + 1)))
          // const subPathOfSubTree = subtractForPath(realTimePath, newPath)

          const subTree = getSubTree(getGlobalTreeData(), newPath)
          // const subTree1 = state.subTreeData
          // const rootNode = state.rootNode
          // const newSubTree = mergedTree(subTree, subTree1, rootNode, subPathOfSubTree)
          const newPathList = state.pathList.slice(0, border)
          newPathList.push({
            text: nodeTitleElement,
            id: node.id,
            onClick: currentPagePnClickHandler
          })

          return {
            path: newPath,
            subTreeData: subTree,
            rootNode: node,
            pathList: newPathList,
            didUpdateAtCurrentPath: false
          }
        })
      }
      let onClickHandler
      if (pathLastIndex > pathIndex) {
        onClickHandler = () => {
          setNextState()
          // -----------------------------------------------------------------------------------------------------------
          registerToUndoManager(setNextState)
        }
        // onClickHandler = debounce(() => {
        //   setNextState()
        //   // -----------------------------------------------------------------------------------------------------------
        //   registerToUndoManager(setNextState)
        // }, 500, { leading: true, trailing: true }
        // )
      } else if (pathLastIndex === pathIndex) {
        onClickHandler = currentPagePnClickHandler
      }

      pathList.push({
        text: nodeTitleElement,
        id: node.id,
        onClick: onClickHandler
      })
      // const subtraction = currentPath[0] + 1
      // getPathListF(node.children, currentPath.slice(1).map((v) => (v - (subtraction))), pathIndex + 1)
      getPathListF(node.children, currentPath.slice(1), pathIndex + 1)
    }
  }
  // -----------------------------------------------------------------------------------------------------------

  getPathListF(treeData, pathExceptedRoot, 0)

  // -----------------------------------------------------------------------------------------------------------
  const topRootName = textToGeneralizedTextElement(globalOnDemandVars.topRootName(), true)

  const topPageOfTopRootOnClickHandler = () => {
    that.state.scrollElement.scrollTop = 0
    defer(() => {
      if (globalOnDemandVars.focusToNodeOfCurrentWindow()) {
        globalOnDemandVars.focusToNodeOfCurrentWindow()()
      }
    })
  }

  const setNextState = () => {
    that.setState((state, props) => {
      const currentMainTree = getGlobalTreeData()
      // const currentSubTree = state.subTreeData
      // const currentRootNode = state.rootNode
      // const currentPath = state.path
      // const newMainTreeData = mergedTree(currentMainTree, currentSubTree, currentRootNode, currentPath)
      return {
        path: [],
        pathList: [
          {
            text: topRootName,
            id: 0,
            onClick: topPageOfTopRootOnClickHandler
          }
        ],
        subTreeData: currentMainTree,
        rootNode: null,
        didUpdateAtCurrentPath: false
      }
    })
  }

  let topRootOnClickHandler
  if (path.length >= 1) {
    topRootOnClickHandler = () => {
      setNextState()
      // -----------------------------------------------------------------------------------------------------------
      registerToUndoManager(setNextState)
    }
    // topRootOnClickHandler = debounce(() => {
    //   setNextState()
    //   // -----------------------------------------------------------------------------------------------------------
    //   registerToUndoManager(setNextState)
    // }, 500, { leading: true, trailing: true }
    // )
  } else if (path.length === 0) {
    topRootOnClickHandler = topPageOfTopRootOnClickHandler
  }

  pathList.unshift({
    text: topRootName,
    id: 0,
    onClick: topRootOnClickHandler
  })

  return pathList
}
